import '/components/faq/faq.scss';
